import { createClient } from '@supabase/supabase-js';

export const supabase = createClient(
  'https://zsgzjgeigmtgdbejghoh.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpzZ3pqZ2VpZ210Z2RiZWpnaG9oIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODczMzI2MjYsImV4cCI6MjAwMjkwODYyNn0.-L2E6QTqz2d2Uf-W8YWv94WIarOT6heak1LWO9A5blo'
);
